import { isHttpErrorType } from '../types/error';

const DEFAULT_ERROR_MESSAGE = 'An unknown error occurred';

export const parseErrorMessage = (error: unknown, defaultMessage = DEFAULT_ERROR_MESSAGE): string =>
	isHttpErrorType(error) ? error.response?.data?.message || defaultMessage : defaultMessage;
